/**
 * Extracts the trigger name from a CREATE TRIGGER SQL statement
 * @param sqlQuery The SQL query containing the CREATE TRIGGER statement
 * @returns The extracted trigger name, or an empty string if not found
 */
export function extractTriggerName(sqlQuery: string): string {
  if (!sqlQuery || sqlQuery.trim() === '') {
    return '';
  }

  const triggerRegex = /CREATE\s+TRIGGER\s+(?:\[?\w+\]?\.)?(\[?\w+\]?)/i;

  const match = sqlQuery.match(triggerRegex);

  if (match && match[1]) {
    // Remove brackets if present
    return match[1].replace(/[[\]]/g, '');
  }

  return '';
}
